module.exports = __webpack_public_path__ + "img/xu-ly-ho-so-icon.16def7ad.svg";